import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="text-center max-w-lg">
          <div className="w-20 h-20 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-6">
            <i className="ri-error-warning-line text-primary-600 text-3xl" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-4">404</h1>
          <h2 className="font-heading text-xl font-semibold text-foreground-800 mb-3">Page Not Found</h2>
          <p className="text-foreground-600 mb-8 leading-relaxed">
            The page you are looking for does not exist or has been moved. Check the URL or return to the homepage.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 text-white font-medium px-6 py-3 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-line" />
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}